"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namecase = namecase;
const crm_service_enums_1 = require("../clients/http/crm-service/crm-service.enums");
const config_1 = require("../config");
function namecase(input, opt) {
    if (Array.isArray(input)) {
        return input.map(function (i) {
            return namecase(i);
        });
    }
    if (typeof input === 'string') {
        return nc(input, opt);
    }
    return input;
}
const companyTitles = {
    [config_1.CountryChannel.EE]: Object.values(crm_service_enums_1.CompanyLegalFormEE),
    [config_1.CountryChannel.LV]: Object.values(crm_service_enums_1.CompanyLegalFormLV),
    [config_1.CountryChannel.LT]: Object.values(crm_service_enums_1.CompanyLegalFormLT)
};
const fixCompanyNames = function (name) {
    Object.values(companyTitles).flat(1).forEach((title) => {
        name = name.replace(new RegExp(`(^${title}\\s|\\s${title}$)`, 'giu'), ` ${title} `).trim();
    });
    return name;
};
// Don't change capitalization unless capitalization isn't set
// Note: Commented out, crashes typescript compiler
/* namecase.checkName = function (name: string): boolean {
  return name === name.toLowerCase() || name === name.toUpperCase()
}

// Strip out extraneous spaces
namecase.normalize = function (name: string): string {
  return name.replace(/\s{2,}/g, ' ')
} */
// Actual case fixing function
const nc = function (el, opt) {
    opt = opt || {};
    el = el
        .trim()
        .toLowerCase();
    // Split names on regex whitespace, dash or apostrophe, workaround for
    // Javascript regex word boundary \b splitting on unicode characters
    // http://stackoverflow.com/questions/5311618/javascript-regular-expression-problem-with-b-and-international-characters
    const splitters = [
        { s: /\s/, r: ' ' },
        // eslint-disable-next-line
        { s: /\-/, r: '-' },
        // eslint-disable-next-line
        { s: /\'/, r: "'" },
        // eslint-disable-next-line
        { s: /\"/, r: '"' },
        { s: /\(/, r: '(' },
        { s: /\./, r: '.' }
    ];
    for (let i = 0; i < splitters.length; i++) {
        const elArr = el.split(splitters[i].s);
        for (let j = 0; j < elArr.length; j++) {
            elArr[j] = elArr[j].charAt(0).toUpperCase() + elArr[j].slice(1);
        }
        el = elArr.join(splitters[i].r);
    }
    // Name case Mcs and Macs
    // Exclude names with 1-2 letters after prefix like Mack, Macky, Mace
    // Exclude names ending in a,c,i,o, or j are typically Polish or Italian
    if (new RegExp(/\bMac[A-Za-z]{2,}[^aciozj]\b/).test(el) || new RegExp(/\bMc/).test(el)) {
        el = el.replace(/\b(Ma?c)([A-Za-z]+)/, function (_x, y, z) {
            return y + z.charAt(0).toUpperCase() + z.substring(1);
        });
        // Now correct for "Mac" exceptions
        el = el
            .replace(/\bMacEvicius\b/, 'Macevicius')
            .replace(/\bMacHado\b/, 'Machado')
            .replace(/\bMacHar\b/, 'Machar')
            .replace(/\bMacHin\b/, 'Machin')
            .replace(/\bMacHlin\b/, 'Machlin')
            .replace(/\bMacIas\b/, 'Macias')
            .replace(/\bMacIulis\b/, 'Maciulis')
            .replace(/\bMacKie\b/, 'Mackie')
            .replace(/\bMacKle\b/, 'Mackle')
            .replace(/\bMacKlin\b/, 'Macklin')
            .replace(/\bMacQuarie\b/, 'Macquarie')
            .replace(/\bMacOmber\b/, 'Macomber')
            .replace(/\bMacIn\b/, 'Macin')
            .replace(/\bMacKintosh\b/, 'Mackintosh')
            .replace(/\bMacKen\b/, 'Macken')
            .replace(/\bMacHen\b/, 'Machen')
            .replace(/\bMacHiel\b/, 'Machiel')
            .replace(/\bMacIol\b/, 'Maciol')
            .replace(/\bMacKell\b/, 'Mackell')
            .replace(/\bMacKlem\b/, 'Macklem')
            .replace(/\bMacKrell\b/, 'Mackrell')
            .replace(/\bMacLin\b/, 'Maclin')
            .replace(/\bMacKey\b/, 'Mackey')
            .replace(/\bMacKley\b/, 'Mackley')
            .replace(/\bMacHell\b/, 'Machell')
            .replace(/\bMacHon\b/, 'Machon')
            .replace(/\bMacHielsen\b/, 'Machielsen');
    }
    // And correct Mac exceptions otherwise missed
    el = el
        .replace(/\bMacmurdo/, 'MacMurdo')
        .replace(/\bMacisaac/, 'MacIsaac')
        // Fixes for "son (daughter) of" etc. in various languages.
        .replace(/\bAl(?=\s+\w)/g, 'al') // al Arabic or forename Al.
        .replace(/\bA([pmn]|an|uf|us)\b/g, 'a$1') // ap Welsh; am, an, auf, aus German; aan Dutch
        .replace(/\bBen(?=\s+\w)\b/g, 'ben') // ben Hebrew or forename Ben.
        .replace(/\bDell([ae])\b/g, 'dell$1') // della and delle Italian.
        .replace(/\bD([aeiu])\b/g, 'd$1') // da, de, di Italian; du French.
        .replace(/\bDe([lrnm])\b/g, 'de$1') // del Italian; der Dutch/Flemish; den, dem Dutch/German
        .replace(/\bTe([\srn])\b/g, 'te$1') // te, ter, ten Dutch
        .replace(/\bEl\b/g, 'el') // el Greek
        .replace(/\bLa\b/g, 'la') // la French
        .replace(/\bL([eo])\b/g, 'l$1') // lo Italian; le French.
        .replace(/\bVan(?=\s+[\w'])/g, 'van') // van German or forename Van.
        .replace(/\bVon\b/g, 'von') // von Dutch/Flemish
        .replace(/\bI([nm])\b/g, 'i$1') // in Dutch/German; im German
        .replace(/\bBij\b/g, 'bij') // bij Dutch
        .replace(/\bU(it|nd)\b/g, 'u$1') // uit, und Dutch/German
        .replace(/\bZu([\smr])\b/g, 'zu$1') // zu, zur, zum German
        .replace(/\bO(p|nder|ver)\b/g, 'o$1') // op, onder, oven Dutch
        .replace(/\b(van|in|bij)\s'[Tt]\b/g, "$1 't") // van 't, in 't, bij 't Dutch
        .replace(/\b(van|in|bij)\sHet\b/g, '$1 het') // van het, in het, bij het Dutch
        // Fixes for roman numeral names, e.g. Henry VIII
        .replace(/\b(?:\d{4}|(?:[IVX])(?:X{0,3}I{0,3}|X{0,2}VI{0,3}|X{0,2}I?[VX]))$/i, function (v) {
        return v.toUpperCase();
    })
        // Nation of Islam 2X, 3X, etc. names
        .replace(/\b[0-9](x)\b/, function (v) {
        return v.toUpperCase();
    })
        // Somewhat arbitrary rule where two letter combos not containing vowels should be capitalized
        // fixes /JJ Abrams/ and /JD Salinger/
        // With some exceptions
        .replace(/(?:^|\s)[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]{2}\s/, function (v) {
        return v.toUpperCase();
    })
        .replace(/\bMR\s/, 'Mr')
        .replace(/\bMS\s/, 'Ms')
        .replace(/\bDR\s/, 'Dr')
        .replace(/\bST\s/, 'St')
        .replace(/\bJR\s/, 'Jr')
        .replace(/\bSR\s/, 'Sr')
        .replace(/\bLT\s/, 'Lt')
        // lowercase words
        .replace(/\bThe\b/g, 'the')
        .replace(/\bOf\b/g, 'of')
        .replace(/\bAnd\b/g, 'and')
        .replace(/\bY\s/g, 'y')
        // strip extra spaces
        .replace(/\s{2,}/g, ' ');
    // check if we should force the first character to caps
    // opt.hasOwnProperty('individualFields') &&
    if (Object.prototype.hasOwnProperty.call(opt, 'individualFields') && opt.individualFields) {
        // first character may be lowercase
        return el;
    }
    if (opt.isLegalCustomer) {
        el = fixCompanyNames(el);
    }
    // force first character to be uppercase
    return el.charAt(0).toUpperCase() + el.substring(1);
};
